//
//
//
//
//
//

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const src = to.query.src;
            if (src) {
                vm.url = src;
            } else {
                vm.getVr();
            }
        });
    },
    data() {
        return {
            url: ''
        };
    },
    methods: {
        getVr() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: 60
                }
            }).then(res => {
                if (res.code === 0) {
                    this.vrData = res.data;
                    this.url = res.data.outUrl;
                }
            });
        }
    }
};
